import { FunctionField, NumberField, ReferenceField, SelectField, TextField, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DetailsSampleList } from '@/components/global/fields/DetailsSampleList.jsx';
import { ServiceCompanyNamesField } from '@/components/global/fields/ServiceCompanyNamesField.jsx';
import { RetailChainLogoField } from '@/components/retailChain/fields/RetailChainLogoField.jsx';
import { brandBasicDetailsStyles } from '@/themes/commonStyles/brandBasicDetails.js';

const StyledBasicDetails = styled(Box)(brandBasicDetailsStyles);
import { depositWithdrawalMethodsChoices, forwarderTypeChoices } from '@/components/global/options/selectOptions.jsx';
import { operatorChoices } from '@/constants/Operators.js';
import { formatOptionalNumberInput } from '@/components/retailChain/validators/retailChainValidators.js';
import { couponSourceChoices, joinChoiceNames, joinDiscountValues } from '@/components/retailChain/configurationDetailValues.js';

export const RetailChainBasicDetails = () => {
    const translate = useTranslate();

    return (
        <StyledBasicDetails>
            <DetailsSampleList
                leading={
                    <Box className='basic-details__logo'>
                        <RetailChainLogoField column />
                    </Box>
                }
            >
                <TextField source='name' label={translate('resources.retailChain.fields.name')} emptyText='—' />
                <TextField source='description' label={translate('resources.retailChain.fields.description')} emptyText='—' />
                <FunctionField source='brands' label={translate('resources.retailChain.fields.brands')} render={() => null} />
                <FunctionField source='contractors' label={translate('resources.retailChain.fields.contractors')} render={() => null} />
                <FunctionField source='collectionPoints' label={translate('resources.retailChain.fields.collectionPoints')} render={() => null} />
            </DetailsSampleList>
        </StyledBasicDetails>
    );
};

RetailChainBasicDetails.propTypes = {};

export const RetailChainConfigurationDetails = () => {
    const translate = useTranslate();

    return (
        <DetailsSampleList>
            <SelectField
                source='forwarderType'
                label={translate('resources.retailChain.fields.forwarderType')}
                choices={forwarderTypeChoices(translate)}
                emptyText='—'
            />
            <FunctionField
                source='operators'
                label={translate('resources.retailChain.fields.operators')}
                render={record => joinChoiceNames(record?.operators, operatorChoices) || '—'}
            />
            <SelectField source='couponSource' label={translate('resources.retailChain.fields.couponSource')} choices={couponSourceChoices} emptyText='—' />
            <FunctionField
                source='depositWithdrawalMethods'
                label={translate('resources.retailChain.fields.depositWithdrawalMethods')}
                render={record => joinChoiceNames(record?.depositWithdrawalMethods, depositWithdrawalMethodsChoices(translate)) || '—'}
            />
            <FunctionField
                source='defaultDepositValue'
                label={translate('resources.retailChain.fields.defaultDepositValue')}
                render={record => formatOptionalNumberInput(record?.defaultDepositValue) || '—'}
            />
            <NumberField source='defaultDepositPoints' label={translate('resources.retailChain.fields.defaultDepositPoints')} emptyText='—' />
            <ServiceCompanyNamesField source='serviceCompanyIds' label={translate('resources.retailChain.fields.serviceCompanies')} />
            <ReferenceField
                source='defaultServiceCompanyId'
                reference='service-company'
                link={false}
                emptyText='—'
                label={translate('resources.retailChain.fields.defaultServiceCompany')}
            >
                <TextField source='name' />
            </ReferenceField>
            <FunctionField
                source='discountLimitL1'
                label={translate('resources.retailChain.labels.discountLimits')}
                render={record => joinDiscountValues(record, 'discountLimitL', value => value)}
            />
            <FunctionField
                source='discountValueL1'
                label={translate('resources.retailChain.labels.discountValues')}
                render={record => joinDiscountValues(record, 'discountValueL', value => `${value}%`)}
            />
        </DetailsSampleList>
    );
};

RetailChainConfigurationDetails.propTypes = {};
